export var FormMode;
(function (FormMode) {
    FormMode[FormMode["CARD"] = 0] = "CARD";
    FormMode[FormMode["MODAL"] = 1] = "MODAL";
})(FormMode || (FormMode = {}));
export const YYYY_MM_DD = 'YYYY-MM-DD';
export const Diet = [
    { label: 'Meat', value: 'meat' },
    { label: 'Fish', value: 'fish' },
    { label: 'Vegetarian', value: 'vegetarian' },
    { label: 'Vegan', value: 'vegan' }
];
export const IngredientTypes = [
    { label: 'Ready Made', value: 'Ready Made' },
    { label: 'Produce', value: 'Produce' },
    { label: 'Dairy', value: 'Dairy' },
    { label: 'Dry', value: 'Dry' },
    { label: 'Water', value: 'Water' },
    { label: 'Grocery', value: 'Grocery' },
    { label: 'Frozen', value: 'Frozen' },
    { label: 'Protein', value: 'Protein' },
    { label: 'Meat', value: 'Meat' },
    { label: 'Vegetable', value: 'Vegetable' },
    { label: 'Sub Prep', value: 'Sub Prep' }
];
export const fallBackImageData = 'data:image/png;base64,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';
export const WEB_IMAGE_PLACEHOLDER = 'https://bellabona-e-commerce.s3.eu-central-1.amazonaws.com/UtilityImages/picture+coming+soon+1200.jpeg';
export const STATIONS = [
    { name: 'Salads & Bowls', value: 'salads_&_bowls' },
    { name: 'Lunch Classics', value: 'lunch_classics' },
    { name: 'Soups & Desserts', value: 'soups_&_desserts' },
    { name: 'Sandwich & Wraps', value: 'sandwich_&_wraps' },
    { name: 'Cucina Italiana', value: 'cucina_italiana' },
    { name: 'Catering', value: 'catering' },
    { name: 'Addons', value: 'addons' },
    { name: 'Addons Prepared', value: 'prepared_addons' },
    { name: 'Veganuary', value: 'veganuary' },
    { name: 'Heat to Eat', value: 'heat_to_eat' },
    { name: 'Premium', value: 'premium' }
];
export const VAT_OPTIONS = [
    { name: '7%', value: 7 },
    { name: '19%', value: 19 }
];
export const CATEGORIESMAP = {
    'Heat to Eat': 'HE',
    Veganuary: 'VG',
    'Cucina Italiana': 'CI',
    'Lunch Classics': 'LC',
    'Sandwich & Wraps': 'SW',
    'Salads & Bowls': 'SB',
    'Soups & Desserts': 'SD',
    Premium: 'PR',
    Addons: 'AD'
};
// types of selecte options
export const OPTIONS = {
    INGREDIENT_TYPE: 'INGREDIENT_TYPE',
    STORAGE: 'STORAGE',
    CATEGORY: 'CATEGORY'
};
// TODO:
// export const MAX_STICKER_NUMBER = 13;
export const STICKER_NUMBER_OPTIONS_WITH_LETTERS = [
    { name: 'A', value: 'A' },
    { name: 'B', value: 'B' },
    { name: 'C', value: 'C' },
    { name: 'D', value: 'D' },
    { name: 'E', value: 'E' },
    { name: 'F', value: 'F' },
    { name: 'G', value: 'G' },
    { name: 'H', value: 'H' },
    { name: 'I', value: 'I' },
    { name: 'J', value: 'J' },
    { name: 'K', value: 'K' },
    { name: 'L', value: 'L' },
    { name: 'M', value: 'M' },
    { name: 'N', value: 'N' },
    { name: 'O', value: 'O' },
    { name: 'P', value: 'P' },
    { name: 'Q', value: 'Q' },
    { name: 'R', value: 'R' },
    { name: 'S', value: 'S' },
    { name: 'T', value: 'T' },
    { name: 'U', value: 'U' },
    { name: 'V', value: 'V' },
    { name: 'W', value: 'W' },
    { name: 'X', value: 'X' },
    { name: 'Y', value: 'Y' },
    { name: 'Z', value: 'Z' },
    { name: 'generic_sticker', value: 'Generic sticker' }
];
export const MEASURE_TYPES = {
    METRIC: 'METRIC',
    UTENSIL: 'UTENSIL'
};
export const TIME_MULTIPLIER = 60000;
